import script from "./CaskToolsSql2kotlin.vue?vue&type=script&setup=true&lang=js"
export * from "./CaskToolsSql2kotlin.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__
import QRadio from 'quasar/src/components/radio/QRadio.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QRadio,QBtn});
